<script>
import store from "@/store";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";

export default {
  name: "SingleProductPriceWrapper",
  props: {
    product: {
      required: true
    },
    digitalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
    physicalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
  },
  data() {
    return {}
  },
  methods: {
    basketAddItem,
    addUnAuthItem,
    isProductActive,
    quantityChecker(product) {
      if (product.variation == 1) {
        return true
      } else {

        if (product.quantity > 0 || product.quantity == null) {
          return true
        }

      }

      return false

    },
  },
  computed: {

  },
  render() {
    return this.$slots.default({
      timing: this.isProductActive(this.product),
      quantity: this.quantityChecker(this.product),
      addToCartFunction: function (product, sub_product) {
        let isAuthenticated = store.getters["User/isAuthenticated"]
        if (isAuthenticated || this.findAttributeOnSiteInfo('cartType')[0] == 1) {
          return basketAddItem(product, sub_product)
        }
        return addUnAuthItem(product, sub_product)
      },
      buttonText: this.product.is_digital == 1 ? this.digitalShoppingCartText : this.physicalShoppingCartText
    });
  },
}
</script>

<style scoped>

</style>